export enum FIELDS_TYPES {
  STRING = "string",
  ID = "id",
  NUMBER = "number",
  USER = "user",
  MULTI_USER = "multi_user",
  MULTI_STRING = "multi_string",
  MULTI_STRING_AND = "multi_string_and",
  DATE = "date",
  LOOKUP = "lookup",
  MULTI_LOOKUP = "multi_lookup",
  LINK = "link",
  BOOLEAN = "boolean",
  CHOICE = "choice",
  SKIP = "skip",
  MEDIA = "media",
  JSON = "json",
  RICH_TEXT = "richtext",
}

export enum STRAPI_FIELDS_TYPES {
  STRING = "string",
  ID = "id",
  NUMBER = "number",
  USER = "user",
  MULTI_USER = "multi_user",
  TEXT = "text",
  RICHT_TEXT = "richtext",
  ENUMERATION = "enumeration",
  EMAIL = "email",
  PASSWORD = "password",
  UID = "uid",
  TIME = "time",
  DATETIME = "datetime",
  TIMESTAMP = "timestamp",
  INTEGER = "integer",
  BIG_INTEGER = "biginteger",
  FLOAT = "float",
  DECIMAL = "decimal",
  BOOLEAN = "boolean",
  JSON = "json",
  MEDIA = "media",
  RELATION = "relation",
  COMPONENT = "component",
  DYNAMIC_ZONE = "dynamiczone",
  LOCALE = "locale",
  LOCALIZATIONS = "localizations",
}

export enum FILTERS_TYPES {
  EQUALS = "equals",
  NOT_EQUALS = "not_equals",
  CONTAINS = "contains",
  NOT_CONTAINS = "not_contains",
  STARTS_WITH = "starts_with",
  ENDS_WITH = "ends_with",
  GREATER_THAN = "greater_than",
  LESS_THAN = "less_than",
  GREATER_THAN_OR_EQUAL_TO = "greater_than_or_equal_to",
  LESS_THAN_OR_EQUAL_TO = "less_than_or_equal_to",
  BETWEEN = "between",
  NOT_BETWEEN = "not_between",
  IN = "in",
  NOT_IN = "not_in",
  IS_EMPTY = "is_empty",
  IS_NOT_EMPTY = "is_not_empty",
  IS_NULL = "is_null",
  IS_NOT_NULL = "is_not_null",
  IS_TRUE = "is_true",
  IS_FALSE = "is_false",
  IS_EMPTY_STRING = "is_empty_string",
  IS_NOT_EMPTY_STRING = "is_not_empty_string",
}
